define.alias("ember-truth-helpers/helpers/or", "settings/helpers/or");